import ProductWithTranslucentDeal from "app/pages/Listing/Product/ProductWithTranslucentDeal";
import React from "react";

export default props => <ProductWithTranslucentDeal {...props} />;
